import * as React from 'react'
import { BankOutlined, SafetyCertificateOutlined } from '@ant-design/icons'
import { Button, Input, List, Modal, PageHeader, Row } from 'antd'
import { Menu, Space, Typography, Tooltip, Spin } from 'antd'

import { DataNode } from 'antd/lib/tree'

import { IConfigurazioneService } from '../../services/ConfigurazioneService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { AccessoCcModel, CatDataNode, ContiCorrentiModel, ContoCorrenteModel } from '../../models/ConfigurazioneModels'
import { ModalCategoria, OperationType } from './ModalCategoria'
import { EsempioCategorie } from './EsempioCategorie'
import Operation from 'antd/lib/transfer/operation'
import Search from 'antd/lib/input/Search'
import { TTAvatar } from '../shared/TTAvatar'
import { ModelBase } from '../../models/ModelBase'
import { IYapilyService } from '../../services/YapilyService'
import { YapilyFlowModel } from '../../models/YapilyModels'
import { RouteComponentProps, withRouter } from 'react-router'
import { TTFormItem } from '../shared/TTFormItem'
import { ConsensiContent } from './ConsensiContent'
const { Text } = Typography

class PageYapilyConsensiState extends YapilyFlowModel {
    PsuIdMandatory: boolean
    PsuCorporateIdMandatory: boolean
    PsuIpAddressMandatory: boolean
}

interface YapilyPropos {
    id: string

}

export class PageYapilyConsensiComp extends React.Component<RouteComponentProps<YapilyPropos>, PageYapilyConsensiState> {

    service: IYapilyService


    constructor(props) {
        super(props)
        this.state = new PageYapilyConsensiState()
        this.service = container.get(SERVICE_IDENTIFIER.YAPILY_SERVICE)
        // const id = this.props.match.params.id
    }


    onClick = async (model: PageYapilyConsensiState) => {
        model = this.state
        model.IdContoCorrente = this.props.match.params.id
        var x = await this.service.StartAuthFlow(model)
        if (x.IsValid == true) {
            window.location.href = x.Code
        }
    }


    render() {
        return (
            <ConsensiContent id={this.props.match.params.id} goto={m => this.onClick(m)} />
        )
    }
}

export const PageYapilyConsensi = withRouter(PageYapilyConsensiComp)